import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { createPinia } from 'pinia'
import './assets/tailwind.css'

axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api'
axios.defaults.withCredentials = true

console.log('[boot] axios baseURL =', axios.defaults.baseURL, '| protocol =', window.location.protocol)

// REQUEST interceptor — runs before EVERY request.
// Upgrades http:// → https:// when the page itself is HTTPS.
// This is the definitive fix for mixed-content regardless of what
// gets baked into VUE_APP_API_URL at build time.
axios.interceptors.request.use(config => {
  if (window.location.protocol === 'https:') {
    if (config.baseURL?.startsWith('http://')) {
      config.baseURL = 'https://' + config.baseURL.slice(7)
    }
    if (config.url?.startsWith('http://')) {
      config.url = 'https://' + config.url.slice(7)
    }
  }
  return config
})

// RESPONSE interceptor — logs failures and handles expired sessions.
axios.interceptors.response.use(
  res => res,
  err => {
    const { config, response } = err
    const method  = config?.method?.toUpperCase() ?? '?'
    const url     = config?.baseURL ? config.baseURL + config.url : (config?.url ?? '?')
    const status  = response?.status ?? 'network error'
    console.error(`[API] ${method} ${url} → ${status}`, response?.data ?? err.message)

    if (response?.status === 401) {
      const path = window.location.pathname
      if (path !== '/login' && path !== '/register' && !path.startsWith('/auth')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)

const app = createApp(App)

document.documentElement.classList.add('dark')

app.use(createPinia())
app.use(router)
app.mount('#app')

import i18n from './i18n'
app.use(i18n)